import { GsFormSchema } from '../../../components';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the shipping calculator component form.
 * Defines the fields to display for the form.
 */
export const SHIPPING_CALCULATOR_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    {
      formControlName: 'buttons',
      label: 'components.shippingCalculator.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
